import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import '@rainbow-me/rainbowkit/styles.css';
import { getDefaultConfig as getDefaultConfig_RK, RainbowKitProvider, darkTheme, connectorsForWallets } from '@rainbow-me/rainbowkit';
import { 
  metaMaskWallet,
  trustWallet,
  injectedWallet,
  walletConnectWallet,
  coinbaseWallet,
  safeWallet,
  okxWallet,
  rainbowWallet,
  safepalWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { createConfig, WagmiProvider } from 'wagmi';
import * as wagmiChains from 'wagmi/chains';
import { http } from 'viem';

import * as c from 'const';
import App from 'App';
import GetQueryClient from 'utils/Query';
import './index.css';
// import reportWebVitals from './reportWebVitals';

const chains = [wagmiChains.bsc];

const BSC_RPC_URL = c.CHAIN_DETAILS.bsc.mainnet.rpc[0] ?? wagmiChains.bsc.rpcUrls.default.http?.[0];

const rkConfig = {
  appName: 'DogeBets',
  chains: chains,
  //projectId: 'PLACEHOLDER', // for WalletConnect
  projectId: '8694ab717426f5b522e7e49b54370a83',
  ssr: false, // server-side rendering
}

const recommendedWallets = [
  metaMaskWallet,
  safepalWallet,
  walletConnectWallet,
  trustWallet,
  injectedWallet,
  //okxWallet,
];

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: recommendedWallets,
      //wallets: [safepalWallet],
    },
  ],
  rkConfig, // required for projectId
);

const wagmiConfig = createConfig({
  connectors,
  ...rkConfig,
  transports: {
    [wagmiChains.bsc.id]: BSC_RPC_URL ? http(BSC_RPC_URL) : http(),
  },
  multiInjectedProviderDiscovery: true, // installed wallet discovery
});

//const wagmiConfig = getDefaultConfig_RK();



const queryClient = GetQueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          modalSize="compact"
          theme={darkTheme({
            accentColor: '#F6D180', // Theme gold color
            accentColorForeground: '#241F31', // Dark text on gold
            borderRadius: 'medium',
            fontStack: 'rounded',
            overlayBlur: 'large',
          })}
          appInfo={{
            appName: 'DogeBets',
            learnMoreUrl: undefined, // Removes the "What is a wallet?" section
          }}
        >
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
